import type { PaginationProps } from '@patrianna/core-components'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { useMemo } from 'react'

import content from 'prismic-translates/transactions-history-page.json'
import RichText from 'src/components/RichText'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])
const FIRST_PAGE = 1

export default function PaginationList({
  total,
  current = FIRST_PAGE,
  onPageChange,
}: Omit<PaginationProps, 'className'>) {
  const pages: number[] = useMemo(() => Array.from({ length: total }, (_, index) => index + FIRST_PAGE), [total])

  return (
    <RichText
      field={t('pagination_page_of')}
      components={{
        paragraph: ({ children }) => <div className={classes.root}>{children}</div>,
        em: ({ children }) => (
          <>
            <div className={classes.rootPaginationList}>
              <select
                name='paginationList'
                value={current}
                onChange={({ target }) => onPageChange(Number(target.value))}
                className={classes.select}
                disabled={total < FIRST_PAGE}
                data-testid='pagination-list-select'
              >
                {pages?.map((page) => (
                  <option key={`option-${page}`} value={page}>
                    {page}
                  </option>
                ))}
              </select>
            </div>

            {children}

            <span data-testid='pagination-total'>{total}</span>
          </>
        ),
      }}
    />
  )
}
